import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import moment from "moment";

import {LeadFilterDataAPI} from "./../../../API/Caller/LeadAPI";
import Sidebar from "./../Common/Sidebar";
import Header from "./../Common/Header";
import Loader from "./../../Loader";
import Paginate from "./../../../utils/Pagination";
import Layout from "./../Layout";
import ContentLoader from "../../../utils/ContentLoader";


const LeadFilter = () =>{

    const {filtertype} = useParams();
    const [leads, setLeads] = useState([]);
    //const [showleads, setShowLeads] = useState(true);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);
    /*const [dispositions, setDispositions] = useState([]);
    const [filterdisposition, setFilterDisposition] = useState(0);
    const [filteremail, setFilterEmail] = useState("");
    const [filtername, setFilterName] = useState("");
    const [isfilterpagination, setIsFilterPagination] = useState(false);*/

    const perpagedata = 20;


    useEffect(() => {

        LeadFilterDataAPI(setLeads, setLoading, currentPage, perpagedata, setPageCount, filtertype);
        

    }, [currentPage]);

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

        //setIsFilterPagination(true);

        //handleFilterLeads();
    }

    /*const handleInputEmailFilter =(e) =>{

        setFilterEmail(e.target.value);
    }

    const handleFilterLeadStatus = (e) =>{
        setFilterDisposition(e.target.value);
    }

    const handleInputNameFilter = (e) =>{
        setFilterName(e.target.value);
    }

    const handleFilterLeads = () =>{

        console.log('Filter Name====' + filtername);
        console.log('Filter Email====' + filteremail);
        console.log('Filter Disposition====' + filterdisposition);

        const filterparams = new URLSearchParams();

        if(filtername)
        {
            filterparams.append('filtername', filtername);
        }

        if(filteremail)
        {
            filterparams.append('filteremail', filteremail);
        }

        if(filterdisposition)
        {
            filterparams.append('filterdisposition', filterdisposition);
        }

        if(currentPage)
        {
            filterparams.append('page', currentPage);
        }

        if(perpagedata)
        {
            filterparams.append('per_page', perpagedata);
        }

        LeadDataAPI(setLeads, setLoading, setShowLeads, currentPage, perpagedata, setPageCount, setDispositions, filterparams);
    }*/


    return(
    <Layout>
        <div className="content">

            <div className="row">
                <div className="col-md-12">

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-8">
                                {filtertype === 'freshlead' ?
                                    <h4 className="page-title">Fresh Leads</h4>
                                :
                                    (filtertype === 'warmleads' ?
                                        <h4 className="page-title">Warm Leads</h4>
                                    :
                                        (filtertype === 'contactedleads' ?
                                            <h4 className="page-title">Contacted Leads</h4>
                                        :
                                            (filtertype === 'deadleads' ?
                                                <h4 className="page-title">Dead Leads</h4>
                                            :
                                                (filtertype === 'coldleads' ?
                                                    <h4 className="page-title">Cold Leads</h4>
                                                :
                                                    (filtertype === 'attemptleads' ?
                                                        <h4 className="page-title">Attempt to Contact Leads</h4>
                                                    :
                                                        (filtertype === 'enrolledleads' ?
                                                            <h4 className="page-title">Enrolled Leads</h4>
                                                        :
                                                            (filtertype === 'totalleads' ?
                                                                <h4 className="page-title">Total Leads</h4>
                                                            :
                                                                <></>
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                }
                            </div>
                            <div className="col-4 text-end">

                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-12">
                    <div className="card">

                        <div className="card-body">

                            <div className="table-responsive table-wrapper">
                                {loading ?
                                    <div>
                                        <ContentLoader />
                                    </div>
                                :
                                <table className="table table-data-section" id="">
                                    <thead className="thead-light">
                                        <tr>
                                            <th style={{ width: "5%" }}>Action</th>
                                            <th style={{ width: "15%" }}>Name</th>
                                            <th style={{ width: "20%" }}>Email</th>
                                            <th style={{ width: "20%" }}>Contact</th>
                                            <th style={{ width: "10%" }}>Location</th>
                                            <th style={{ width: "10%" }}>Program</th>
                                            <th style={{ width: "10%" }}>Institute</th>
                                            <th style={{ width: "15%" }}>Lead Status</th>
                                            <th style={{ width: "15%" }}>Created Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                    {leads && leads.length > 0  ?
                                        leads.map(lead =>
                                        (

                                            <tr key={lead.id}>
                                                <td>
                                                    <Link to={`/caller/lead-profile/${lead.id}`} className="">
                                                        <i className="fa fa-pencil"></i>
                                                    </Link>
                                                </td>

                                                <td>{lead.name}</td>
                                                <td>{lead.email}</td>
                                                <td>{lead.contact}</td>
                                                <td>{lead.location}</td>
                                                <td>{lead.program}</td>
                                                <td>{lead.institute}</td>
                                                <td>
                                                    {lead.leadstatus ?
                                                        <span class="badge badge-tag badge-purple-light">{lead.leadstatus}</span>
                                                    :
                                                        <span>-</span>
                                                    }
                                                </td>
                                                <td>{moment(lead.created_at).format('DD-MM-YYYY h:mm')} </td>

                                            </tr>
                                        ))

                                        :

                                            <tr>
                                                <td colSpan="9">
                                                    <p>No record found...</p>
                                                </td>
                                            </tr>
                                    }

                                    </tbody>
                                </table>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                {pagecount > 1 ?
                <div className="pagination-section mt-3">

                    <nav>
                        <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                    </nav>
                </div>
                :
                    <></>
                }
            </div>
        </div>
    </Layout>
    )
}

export default LeadFilter;
